/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IbanEnhanced } from "./IbanEnhanced";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const IbansEnhancedR = t.interface({
  ibans_enhanced: t.readonlyArray(IbanEnhanced, "array of IbanEnhanced"),

  page_info: PageInfo
});

// optional attributes
const IbansEnhancedO = t.partial({});

export const IbansEnhanced = t.intersection(
  [IbansEnhancedR, IbansEnhancedO],
  "IbansEnhanced"
);

export type IbansEnhanced = t.TypeOf<typeof IbansEnhanced>;
